export default "__VITE_ASSET__CrWpacIu__"